import React, {FunctionComponent} from 'react';
import OldUrls from '../../models/utils/OldUrls';

type LastEventsRowProp = {
  id: number
  title: string
  date: React.ReactNode
  students: number
  evaluations: number
  certificates: number
}

const LastEventsRow: FunctionComponent<LastEventsRowProp> = ({
  id, title, date, students, evaluations, certificates,
}) =>
  (
    <>
      <div className="col-span-6"><a href={OldUrls.event(id)} className="text-blue">{title}</a>
      </div>
      <div className="col-span-6">
        <div className="grid grid-cols-7">
          <div className="col-span-4">{date}</div>
          <div className="text-right">{students}</div>
          <div className="text-right">{evaluations}</div>
          <div className="text-right">{certificates}</div>
        </div>
      </div>
    </>
  );

export default LastEventsRow;
